import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  productAttributesApi,
} from "@/services/productAttributesApi";
import { SpecificationSchemaCreate, SpecificationSchemaUpdate } from "@/types/productAttributes";
import { toast } from "@/components/ui/use-toast";

export const useProductAttributes = () => {
  return useQuery({
    queryKey: ["productAttributes"],
    queryFn: () => productAttributesApi.getAll(),
  });
};

export const useProductAttribute = (id: string) => {
  return useQuery({
    queryKey: ["productAttributes", id],
    queryFn: () => productAttributesApi.getById(id),
    enabled: !!id,
  });
};

export const useCreateProductAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SpecificationSchemaCreate) => productAttributesApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["productAttributes"] });
      toast({
        title: "成功",
        description: "產品屬性創建成功",
      });
    },
    onError: (error: any) => {
      toast({
        title: "錯誤",
        description:
          error.response?.data?.detail || "創建產品屬性失敗",
        variant: "destructive",
      });
    },
  });
};

export const useUpdateProductAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: SpecificationSchemaUpdate }) =>
      productAttributesApi.update(id, data),
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["productAttributes"] });
      queryClient.invalidateQueries({ queryKey: ["productAttributes", id] });
      toast({
        title: "成功",
        description: "產品屬性更新成功",
      });
    },
    onError: (error: any) => {
      toast({
        title: "錯誤",
        description:
          error.response?.data?.detail || "更新產品屬性失敗",
        variant: "destructive",
      });
    },
  });
};

export const useDeleteProductAttribute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => productAttributesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["productAttributes"] });
      toast({
        title: "成功",
        description: "產品屬性刪除成功",
      });
    },
    onError: (error: any) => {
      toast({
        title: "錯誤",
        description:
          error.response?.data?.detail || "刪除產品屬性失敗",
        variant: "destructive",
      });
    },
  });
};